const selectors = {
  ToggleButton: ".locale-switcher--btn-toggle",
  LocaleList: ".locale-switcher--list",
  LocaleButton: ".locale-switcher--list--btn-locale",
};

export default selectors;
